import { baseUrl } from '../http'
import axios from 'axios'

export const companiesApi = {
  all (pagination) {
    return axios.get(`${baseUrl}/company/all${parsePagination(pagination)}`)
  },

  unread: (pagination) => {
    return axios.get(`${baseUrl}/company/all/unread${parsePagination(pagination)}`)
  },

  create (companyData) {
    return axios.put(`${baseUrl}/company/register`, companyData)
  },

  get: (id) => {
    return axios.get(`${baseUrl}/company/${id}`)
  },

  getDocuments: (id) => {
    return axios.get(`${baseUrl}/company/${id}/documents`)
  }
}

function parsePagination (pagination) {
  return `?items=${pagination.perPage}&page=${pagination.currentPage - 1}`
}
